import styled from "styled-components";
import { useContext, useEffect } from "react";
import ChatIcon from "./ChatIcon";
import AppContext from "../../../AppContext";

const StyledChatWindow = styled.div`
    &.chat-component,
    &.chat-component * {
        box-sizing: border-box;
    }
    &.chat-component {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 99990;
    }

    .chat-icon {
        position: absolute;
        width: 48px;
        height: 48px;
        bottom: 64px;
        right: 30px;
        z-index: 99990;
    }
`;

/** ChatComponent renders the floating icon that opens and closes the NanaBO side panel.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} [props.className] - Additional class names for styling the chat component.
 * @param {Object} [props.style] - Inline styles for the chat component.
 * @returns {JSX.Element} The rendered chat icon component.
 */
export default function ChatComponent(props) {
    // #region VARS
    const { className = "", style = {} } = props;
    const { aiChatIsVisible, setAiChatWindowOpen, setAiChatSidePanelOpen, aiChatIsDisabled } = useContext(AppContext);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (aiChatIsDisabled || !aiChatIsVisible) {
            setAiChatWindowOpen(false);
            setAiChatSidePanelOpen(false);
        }
    }, [aiChatIsDisabled, aiChatIsVisible]);
    // #endregion

    return (
        <StyledChatWindow
            className={`chat-component ${className} ${!aiChatIsVisible ? "hidden" : "visible"}`}
            style={style}>
            <ChatIcon />
        </StyledChatWindow>
    );
}
